export const OFFICE = 'OFFICE'; // office or home
export const HOME = 'HOME'; // office or home
export const YES = 'YES'; // travel for work
export const NO = 'NO'; // travel for work
export const CONSULTING_AND_STRATEGY = 'CONSULTING_AND_STRATEGY'; // area of accenture
export const INTERACTIVE = 'INTERACTIVE'; // area of accenture
export const TECHNOLOGY = 'TECHNOLOGY'; // area of accenture
export const OPERATIONS = 'OPERATIONS'; // area of accenture
export const CORPORATE_FUNCTIONS = 'CORPORATE_FUNCTIONS'; // area of accenture